import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

import { useAppSettings } from "@/components/app-settings/app-settings-provider";
import { Card } from "@/components/ui/card";
import { workbenchRoutes } from "@/lib/routes/workbench-routes";
import { useAuth } from "./auth-provider";

export function ProtectedAdminRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  const { t } = useAppSettings();

  if (status === "loading") {
    return (
      <main className="flex min-h-screen items-center justify-center bg-background px-4">
        <Card className="px-4 py-3 text-sm text-muted-foreground">{t("auth.loading")}</Card>
      </main>
    );
  }

  if (status === "anonymous") {
    return <Navigate to={workbenchRoutes.login} replace state={{ from: location }} />;
  }

  return children;
}
